module.exports = __webpack_public_path__ + "static/img/ABUIABADGAAgruzrmAYoyuOThAUw3gM4-AI.12e3a35.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ABUIABADGAAgruzrmAYoyuOThAUw3gM4-AI.gif
// module id = 8wJv
// module chunks = 1